export const systemLogsTypes = {
    GET_SYSTEM_LOGS_REQUEST: 'GET_SYSTEM_LOGS_REQUEST',
    GET_SYSTEM_LOGS_SUCCESS: 'GET_SYSTEM_LOGS_SUCCESS',
    GET_SYSTEM_LOGS_FAILURE: 'GET_SYSTEM_LOGS_FAILURE',
}